import { render } from "./KYCWizard.vue?vue&type=template&id=3e82445a"
import script from "./KYCWizard.vue?vue&type=script&lang=js"
export * from "./KYCWizard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__